import React from 'react';
import { useAtomValue } from 'jotai';
import { metricPanelShareAtom } from '@components/metrics-panel-hz/atoms';
import { panelsAtom } from '@src/atoms/panels';
import { DASHBOARD_TYPE, isAppModule } from '@utils/constants';
import useSaveSet, { SavingStateObjectType } from '@components/saving/useSaveSet';
import { diagnosticsAtom } from '@src/atoms/toggles';

// TODO: evaluate merging of save/share data and apply flows

function LatchSave({ pageKeyForSaveService, savingState }) {
  const metricPanel = useAtomValue(metricPanelShareAtom);
  const sections = useAtomValue(panelsAtom);
  const diagnostics = useAtomValue(diagnosticsAtom);

  const { state, ...meta } = savingState;

  const formattedState = {
    ...meta,
    state: {
      ...state,
      metricPanel,
      toggles: {
        sections,
        diagnostics,
      },
    },
  };

  // save can be triggered form close button as well as the kebab
  // TODO: it should be set from a generic section/root instead
  const saveData: SavingStateObjectType = {
    meta: { dashboardTypeId: isAppModule ? DASHBOARD_TYPE.APP_EXPERIENCE : DASHBOARD_TYPE.TRENDS },
    config: formattedState,
  };

  useSaveSet({
    pageKey: pageKeyForSaveService,
    saveData,
  });

  return <></>;
}

export default LatchSave;
